import { ProductVideo } from 'components/ProductVideo';
import shareReplayLight from "../../../../contents/images/docs/session-replay/share-replay-light-mode.mp4";
import shareReplayDark from "../../../../contents/images/docs/session-replay/share-replay-dark-mode.mp4";
import * as React from 'react';
export default {
  ProductVideo,
  shareReplayLight,
  shareReplayDark,
  React
};